module.exports = __webpack_public_path__ + "img/icon-remove.4586cc08.svg";